import Notification from 'components/ui/base/notification/Notification';
import { getErrorMessage } from 'utils/getErrorMessage';

type Options = {
    success: string;
    failure: string;
};

/**
 * Runs an action and reports the outcome as a notification, resolving to whether it succeeded so the
 * caller can decide what follows — refreshing a listing, closing a modal — without repeating the
 * try/catch and the two notification calls at every call site.
 */
export const runWithNotification = async (
    action: () => Promise<unknown>,
    { success, failure }: Options
): Promise<boolean> => {
    try {
        await action();
        Notification({
            type: 'success',
            placement: 'top',
            messageTitle: 'Operation Successful',
            description: success,
        });
        return true;
    } catch (error) {
        Notification({
            type: 'error',
            placement: 'top',
            messageTitle: 'Operation Failed',
            description: getErrorMessage(error) || failure,
        });
        return false;
    }
};
